import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import FilterableListView from "app/static/frontend/search-new/components/FilterableListView/index"

// selectors
import { selectSearchShouldHideFilters } from "shared/userdata/userdata-selectors"
import {
    selectAreMobileSearchFiltersOpen,
    selectCurrentFilters,
    selectHasNewFiltersOnInitialLoad,
    selectIsDisplayOpen,
    selectIsLoading,
} from "shared/search/selectors"
import { updateFilter } from "shared/search/action-creators"
import { selectListViewScrollTop, selectSearchTerm, selectSearchValue } from "app/static/frontend/search-new/selectors"
import { selectStancesWithCustomLabels } from "shared/stance/selectors"

import {
    segueToSearch,
    setMobileFiltersOpenStatus,
    setNextSearchURL,
    setSearchBarData,
    setSearchTerm,
    storeScrollTopPositions,
} from "app/static/frontend/search-new/action-creators"

// action creators
import {
    segue,
    segueToEditBill,
    segueToEditComment,
    segueToEditContact,
    segueToEditDonation,
    segueToEditEvent,
    segueToEditInteraction,
    segueToEditOfficial,
    segueToEditOrganization,
    segueToEditPoliticalCommittee,
    segueToEditPressContact,
    segueToEditRegulation,
    segueToEditRelationship,
    segueToModifyOrganization,
    segueToOutboxCompose,
    segueToOutboxComposeSupporter,
} from "app/static/frontend/global-action-creators"
import { removeResourceTableRow, updateResourceTableRow } from "app/static/frontend/sheets/sheet-action-creators"
import { setOrCreatePriority, setOrCreateStance } from "shared/profiles/position/action-creators"
import { postProfileAlignment } from "shared/stakeholder/action-creators"

const mapStateToProps = createStructuredSelector({
    areMobileSearchFiltersOpen: selectAreMobileSearchFiltersOpen,
    currentFilters: selectCurrentFilters,
    hasNewFiltersOnInitialLoad: selectHasNewFiltersOnInitialLoad,
    isDisplayOpen: selectIsDisplayOpen,
    isLoading: selectIsLoading,
    listViewScrollTop: selectListViewScrollTop,
    shouldHideFilters: selectSearchShouldHideFilters,
    searchFilterTerm: selectSearchValue("searchFilterTerm"),
    searchTerm: selectSearchTerm,
    stanceOptions: selectStancesWithCustomLabels,
})

const actions = {
    postProfileAlignment,
    removeResourceTableRow,
    segue,
    segueToEditBill,
    segueToEditComment,
    segueToEditContact,
    segueToEditDonation,
    segueToEditInteraction,
    segueToEditOfficial,
    segueToEditOrganization,
    segueToEditPoliticalCommittee,
    segueToEditRegulation,
    segueToEditRelationship,
    segueToModifyOrganization,
    segueToOutboxCompose,
    segueToOutboxComposeSupporter,
    segueToSearch,
    setMobileFiltersOpenStatus,
    setNextSearchURL,
    setOrCreatePriority,
    setOrCreateStance,
    setSearchBarData,
    setSearchTerm,
    storeScrollTopPositions,
    updateFilter,
    updateResourceTableRow,
}

export default connect(mapStateToProps, actions)(FilterableListView)
